import CategoryRow from 'components/pages/chart/DHDiagnosisPlanEvaluationChart/CategoryRow';
import styles from 'styles/pages/chart/DHDiagnosisPlanEvaluation.module.scss';

type TProps = {
  isRegister: boolean;
  isReadOnly: boolean;
};

const DHDiagnosisPlanEvaluationChart = ({ isRegister, isReadOnly }: TProps) => {
  return (
    <>
      <table className="w100">
        <thead>
          <tr className={styles.thead_tr}>
            <th className={styles.th}></th>
            <th className={styles.th}>
              <span className="fw700 fs16 lh24">치위생진단문</span>
              <br />
              <span className={styles.th_title}>DH Diagnosis</span>
            </th>
            <th className={styles.th}>
              <span className="fw700 fs16 lh24">치위생계획</span>
              <br />
              <span className={styles.th_title}>DH Plan</span>
            </th>
            <th className={styles.th}>
              <span className="fw700 fs16 lh24">치위생평가</span>
              <br />
              <span className={styles.th_title}>DH Evaluation</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {CategoryRow({
            categoryTitle: '심미\n요인',
            factorName: 'aesthetic',
            isRegister: isRegister && !isReadOnly,
          })}
          {CategoryRow({
            categoryTitle: '치과\n공포\n요인',
            factorName: 'dentalFear',
            isRegister: isRegister && !isReadOnly,
          })}
          {CategoryRow({
            categoryTitle: '전신\n건강\n요인',
            factorName: 'medicalHistory',
            isRegister: isRegister && !isReadOnly,
          })}
          {CategoryRow({
            categoryTitle: '구강\n위생\n상태\n요인',
            factorName: 'oralHygiene',
            style: { borderBottomLeftRadius: '8px' },
            isRegister: isRegister && !isReadOnly,
          })}
          {CategoryRow({
            categoryTitle: '두경부\n통증\n요인',
            factorName: 'headAndNeckPain',
            isRegister: isRegister && !isReadOnly,
          })}
          {CategoryRow({
            categoryTitle: '치아\n요인',
            factorName: 'dental',
            isRegister: isRegister && !isReadOnly,
          })}
          {CategoryRow({
            categoryTitle: '구강\n건강\n책임\n(실천)',
            factorName: 'oralHealthAction',
            isRegister: isRegister && !isReadOnly,
          })}
          {CategoryRow({
            categoryTitle: '구강\n건강\n이해\n(지식)',
            factorName: 'oralHealthKnowledge',
            style: { borderBottomLeftRadius: '8px' },
            isRegister: isRegister && !isReadOnly,
          })}
        </tbody>
      </table>
    </>
  );
};

export default DHDiagnosisPlanEvaluationChart;
